import { Component, HostListener, OnInit } from '@angular/core';
import { isMobileScreenSize } from '@nk/utils-lib';

@Component({
  selector: 'nk-sub-navigation',
  templateUrl: './sub-navigation.component.html',
  standalone: false,
})
export class SubNavigationComponent implements OnInit {
  public isMobile = false;
  @HostListener('window:resize', ['$event'])
  public onResize(): void {
    this.isMobile = isMobileScreenSize();
  }

  public ngOnInit(): void {
    this.isMobile = isMobileScreenSize();
  }
}
